import Home from "layouts/docs/home";
import About from "layouts/docs/about";
import DataDownloads from "layouts/docs/downloads/data"
import CodeDownloads from "layouts/docs/downloads/code"
import ModelDownloads from "layouts/docs/downloads/model"
import CityMap from "layouts/maps/cities"
import StateMap from "layouts/maps/states"
// @mui icons
import Icon from "@mui/material/Icon";
import Charts from "layouts/charts/charts";

const routes = [
  {
    type: "component",
    name: "About",
    key: "about",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/about",
    component: <About />,
  },
  // divider //
  { type: "divider", key: "divider-2" },
  {
    type: "component",
    name: "Maps 2022",
    key: "2022",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2022/cities2022",
    component: <CityMap key='c-2022' url={'SolarSentiment_Cities_2022.geojson'} year={2022}/>, 
  },
  {
    type: "component",
    name: "Maps 2021",
    key: "2021",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2021/cities2021",
    component: <CityMap key='c-2021' url={'SolarSentiment_Cities_2021.geojson'} year={2021}/>,
  },
  {
    type: "component",
    name: "Maps 2020",
    key: "2020",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2020/cities2020",
    component: <CityMap key='c-2020' url={'SolarSentiment_Cities_2020.geojson'} year={2020}/>,
  },
  {
    type: "component",
    name: "Maps 2019",
    key: "2019",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2019/cities2019",
    component: <CityMap key='c-2019' url={'SolarSentiment_Cities_2019.geojson'} year={2019}/>,
  },
  {
    type: "component",
    name: "Maps 2018",
    key: "2018",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2018/cities2018",
    component: <CityMap key='c-2018' url={'SolarSentiment_Cities_2018.geojson'} year={2018}/>,
  },
  {
    type: "component",
    name: "Maps 2017",
    key: "2017",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2017/cities2017",
    component: <CityMap key='c-2017' url={'SolarSentiment_Cities_2017.geojson'} year={2017}/>,
  },
  {
    type: "component",
    name: "Maps 2016",
    key: "2016",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2016/cities2016",
    component: <CityMap key='c-2016' url={'SolarSentiment_Cities_2016.geojson'} year={2016}/>,
  },
  {
    type: "component",
    name: "Maps 2015",
    key: "2015",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2015/cities2015",
    component: <CityMap key='c-2015' url={'SolarSentiment_Cities_2015.geojson'} year={2015}/>,
  },
  {
    type: "component",
    name: "Maps 2014",
    key: "2014",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2014/cities2014",
    component: <CityMap key='c-2014' url={'SolarSentiment_Cities_2014.geojson'} year={2014}/>,
  },
  {
    type: "component",
    name: "Maps 2013",
    key: "2013",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/2013/cities2013",
    component: <CityMap key='c-2013' url={'SolarSentiment_Cities_2013.geojson'} year={2013}/>,
  },
  // divider //
  { type: "divider", key: "divider-1" },
  {
    type: "component",
    name: "Data Download",
    key: "data",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/data",
    component: <DataDownloads />,
  },
  {
    type: "component",
    name: "Fine-Tuned Model",
    key: "model",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/model",
    component: <ModelDownloads />,
  },
  {
    type: "component",
    name: "Code",
    key: "code",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/code",
    component: <CodeDownloads />,
  },
  //Hidden Components (modified in sidenav/index.js)  
  {
    type: "component",
    name: "",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "home",
    component: <Home />, 
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2022",
    route: "/2022/states2022",
    component: <StateMap key='s-2022' url={'SolarSentiment_States_2022_N.geojson'} year={2022}/>,
    hidden: true, 
  },
  {
    type: "component",
    name: "",
    key: "2021",
    route: "/2021/states2021",
    component: <StateMap key='s-2021' url={'SolarSentiment_States_2021_N.geojson'} year={2021}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2020",
    route: "/2020/states2020",
    component: <StateMap key='s-2020' url={'SolarSentiment_States_2020_N.geojson'} year={2020}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2019",
    route: "/2019/states2019",
    component: <StateMap key='s-2019' url={'SolarSentiment_States_2019_N.geojson'} year={2019}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2018",
    route: "/2018/states2018",
    component: <StateMap key='s-2018' url={'SolarSentiment_States_2018_N.geojson'} year={2018}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2017",
    route: "/2017/states2017",
    component: <StateMap key='s-2017' url={'SolarSentiment_States_2017_N.geojson'} year={2017}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2016",
    route: "/2016/states2016",
    component: <StateMap key='s-2016' url={'SolarSentiment_States_2016_N.geojson'} year={2016}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2015",
    route: "/2015/states2015",
    component: <StateMap key='s-2015' url={'SolarSentiment_States_2015_N.geojson'} year={2015}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2014",
    route: "/2014/states2014",
    component: <StateMap key='s-2014' url={'SolarSentiment_States_2014_N.geojson'} year={2014}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "2013",
    route: "/2013/states2013",
    component: <StateMap key='s-2013' url={'SolarSentiment_States_2013_N.geojson'} year={2013}/>,
    hidden: true,
  },
  {
    type: "component",
    name: "",
    key: "data-vis",
    route: "/data-vis",
    component: <Charts url={'NC_solar_sentiment.csv'} />,
    hidden: true,
  }
];

export default routes;